import React, { Component } from 'react';
import { observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';
import moment from 'moment';
import { toast } from 'react-toastify';
import PageTitle from '../../../components/common/PageTitle';
import FeatherIcon from 'feather-icons-react';
import history from '../../../utils/history';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import {
  Button,
  Card, CardBody, CardHeader,
  FormCheckbox, FormInput,
  Row, Col
} from 'shards-react';

// 템플릿 정의 — Quill 에디터가 보존하는 마크업(heading, color, align, strong, list, blockquote)만 사용
const TEMPLATES = [
  {
    key: 'update',
    label: '업데이트 공지',
    icon: 'zap',
    title: '✨ v2.0 업데이트 안내',
    accentColor: '#4A6CF7',
    content:
`<h2 style="color: rgb(74, 108, 247); text-align: center;">✨ v2.0 업데이트</h2>
<p style="text-align: center; color: rgb(100, 116, 139);">더 편하게, 더 빠르게 리뷰를 관리하세요.</p>
<p><br></p>
<h3 style="color: rgb(74, 108, 247);">주요 업데이트 내용</h3>
<ol>
  <li><strong>새로운 위젯 레이아웃</strong> — 더 깔끔하고 반응형</li>
  <li><strong>리뷰 필터 속도</strong> 2배 향상</li>
  <li><strong>AI 답글 품질</strong> 개선</li>
  <li><strong>다국어 지원</strong> 확장 (EN, JP)</li>
</ol>
<p><br></p>
<blockquote><strong>업데이트 적용일</strong>: YYYY-MM-DD</blockquote>`
  },
  {
    key: 'notice',
    label: '안내 공지',
    icon: 'info',
    title: '📢 서비스 안내',
    accentColor: '#0EA5E9',
    content:
`<h3 style="color: rgb(14, 165, 233);">안녕하세요, 온리플입니다.</h3>
<p>서비스 이용과 관련하여 <strong>중요한 안내 사항</strong>을 전달 드립니다.</p>
<p><br></p>
<blockquote>
  <strong>공지 본문</strong><br>
  여기에 상세 내용을 입력해 주세요.
</blockquote>
<p><br></p>
<p style="color: rgb(100, 116, 139);"><em>궁금한 점은 언제든 고객센터로 문의 부탁드립니다.</em></p>`
  },
  {
    key: 'event',
    label: '이벤트 공지',
    icon: 'gift',
    title: '🎉 특별 이벤트 진행 중!',
    accentColor: '#F59E0B',
    content:
`<h2 style="color: rgb(245, 158, 11); text-align: center;">🎁 이달의 이벤트</h2>
<p style="text-align: center;"><strong>지금 참여하고 혜택을 받아가세요!</strong></p>
<p><br></p>
<p><strong>📅 이벤트 기간</strong>: YYYY-MM-DD ~ YYYY-MM-DD</p>
<p><strong>👥 참여 대상</strong>: 전체 고객</p>
<p><strong>🎯 참여 방법</strong>: 여기에 방법을 입력하세요.</p>
<p><br></p>
<blockquote style="color: rgb(146, 64, 14);">
  <strong>🎊 특별 혜택</strong><br>
  이벤트 상세 혜택 내용을 입력해 주세요.
</blockquote>`
  },
  {
    key: 'upgrade',
    label: '요금제 업그레이드',
    icon: 'trending-up',
    title: '📈 요금제 업그레이드 안내',
    accentColor: '#7C3AED',
    content:
`<h2 style="color: rgb(124, 58, 237); text-align: center;">📈 주문 수가 꾸준히 상승하고 있어요</h2>
<p style="text-align: center; color: rgb(100, 116, 139);">현재 요금제의 한도에 도달하여, 업그레이드를 안내드립니다.</p>
<p><br></p>
<blockquote style="color: rgb(124, 58, 237);">
  할인되지 않은 정상가로 <strong>상위 요금제</strong>로 적용되고 있으며, <strong>결제한 금액을 초과</strong>하는 경우 <strong>서비스가 중지</strong>됩니다.<br>
  서비스가 중단되지 않도록 <strong>한 단계 상위 요금제로 업그레이드 결제</strong>를 부탁드립니다.
</blockquote>
<p><br></p>
<h3 style="color: rgb(124, 58, 237);">왜 업그레이드가 필요한가요?</h3>
<ol>
  <li><strong>위젯의 트래픽이 주문 수에 따라 발생</strong>되어, 주문이 많아질수록 리뷰 위젯 노출·요청량도 함께 증가합니다.</li>
  <li>현재 요금제의 트래픽 한도에 도달하여, 한도를 넘기면 <strong>위젯 노출이 일시 중단</strong>될 수 있습니다.</li>
  <li>상위 요금제로 업그레이드하시면 <strong>중단 없이 안정적으로</strong> 위젯과 부가 기능을 이용하실 수 있습니다.</li>
</ol>
<p><br></p>
<p style="text-align: center;"><strong>요금제 / 결제 페이지에서 업그레이드를 진행해 주세요.</strong></p>
<p><br></p>
<blockquote style="color: rgb(124, 58, 237);">
  <strong>📘 결제 플랜 변경 방법 안내</strong><br>
  <a href="https://onnomad.co.kr/admin/manual/edit/6968913a42b69734a543254f?ch=6&amp;sec=5" target="_blank" rel="noreferrer">매뉴얼 페이지 바로가기</a> 를 참고하여 처리 부탁드립니다.
</blockquote>
<p style="text-align: center; color: rgb(100, 116, 139); font-size: 13px;"><a href="https://ocadmin.onreview.co.kr/inquiry" target="_blank" rel="noreferrer">문의하기</a>, 혹은 오른쪽 하단에 <span style="display: inline-block; width: 24px; height: 24px; background: #5664D2; border-radius: 50%; vertical-align: middle; margin: 0 2px; position: relative;"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg></span> <strong>상담톡</strong>을 문의 부탁드립니다.</p>`
  },
  {
    key: 'image',
    label: '이미지 배너',
    icon: 'image',
    title: '',
    accentColor: '#6366F1',
    content:
`<p style="text-align: center;"><em>상단 툴바의 이미지 아이콘을 눌러 배너를 업로드 하세요.</em></p>
<p><br></p>
<p>이미지에 대한 설명을 입력해 주세요.</p>`
  },
  {
    key: 'blank',
    label: '빈 템플릿',
    icon: 'file',
    title: '',
    accentColor: '#4A6CF7',
    content: ''
  }
];

@inject(({ common }) => ({
  getAdminLoginNotice: common.getAdminLoginNotice,
  getAdminLoginNoticeList: common.getAdminLoginNoticeList,
  saveAdminLoginNotice: common.saveAdminLoginNotice,
  removeAdminLoginNotice: common.removeAdminLoginNotice,
  updateAdminLoginNotice: common.updateAdminLoginNotice,
  base64UploadImages: common.base64UploadImages
}))
@inject(({ AOA }) => ({ getAllStoreList: AOA.getAllStoreList }))
@inject(({ teamUser }) => ({ isLogin: teamUser.isLogin, me: teamUser.me }))
@observer
class LoginNoticePopup extends Component {

  @observable isLoading = false;
  @observable notices = [];                // 다중 팝업 목록
  @observable editingId = null;            // 편집 중인 팝업 _id (null이면 신규)
  @observable showEditor = false;          // 편집 영역 표시 여부
  @observable notice = {
    isActive: false,
    title: '',
    content: '',
    backgroundColor: '#FFFFFF',
    accentColor: '#4A6CF7',
    startAt: '',
    endAt: '',
    targetMode: 'all',         // all | include | exclude
    targetStoreKeys: [],       // platformId / store_id / 스토어명 배열
    displayPages: ['dashboard'], // 'dashboard' | 'review' | 'widget' (다중 선택)
    showSkipToday: true        // "오늘 하루 보지 않기" 버튼 노출 여부
  };
  @observable selectedTemplateKey = null;
  @observable isUploading = false;

  // 스토어 검색 / 선택 상태
  @observable storeSearchQuery = '';
  @observable storeSearchResults = [];
  @observable storeSearchLoading = false;
  @observable storeSearchOpen = false;
  storeKeyToName = {};   // observable 아님 — 단순 캐시 (key → display name)
  storeSearchTimer = null;

  fileInputRef = React.createRef();
  quillRef = React.createRef();

  // Quill 툴바 + 이미지 핸들러
  quillModules = {
    toolbar: {
      container: [
        [{ 'header': [1, 2, 3, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'align': [] }],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        ['blockquote', 'link', 'image'],
        ['clean']
      ],
      handlers: {
        image: () => this.triggerUpload()
      }
    },
    clipboard: { matchVisual: false }
  };

  quillFormats = [
    'header', 'bold', 'italic', 'underline', 'strike',
    'color', 'background', 'align',
    'list', 'bullet', 'blockquote', 'link', 'image'
  ];

  componentDidMount() {
    const me = this.props.me || {};
    if (me.emailId !== 'admin@onnomads.com') {
      toast.error('접근 권한이 없습니다.');
      history.replace('/dashboard');
      return;
    }
    this.loadList();
  }

  // 다중 팝업 목록 로드
  @action
  loadList = async () => {
    this.isLoading = true;
    let _this = this;
    this.props.getAdminLoginNoticeList(function(list) {
      _this.notices = Array.isArray(list) ? list : [];
      _this.isLoading = false;
    });
  };

  // 빈 폼으로 초기화 (신규 작성)
  @action
  resetForm = () => {
    this.editingId = null;
    this.notice = {
      isActive: false, title: '', content: '',
      backgroundColor: '#FFFFFF', accentColor: '#4A6CF7',
      startAt: '', endAt: '',
      targetMode: 'all', targetStoreKeys: [],
      displayPages: ['dashboard'],
      showSkipToday: true
    };
    this.selectedTemplateKey = null;
    this.storeSearchQuery = '';
    this.storeSearchResults = [];
    this.storeSearchOpen = false;
  };

  // 신규 팝업 작성 시작
  @action
  startCreate = () => {
    this.resetForm();
    this.showEditor = true;
  };

  // 기존 팝업 편집 시작
  @action
  startEdit = (item) => {
    this.editingId = item._id;
    this.notice = {
      isActive: !!item.isActive,
      title: item.title || '',
      content: item.content || '',
      backgroundColor: item.backgroundColor || '#FFFFFF',
      accentColor: item.accentColor || '#4A6CF7',
      startAt: item.startAt ? moment(item.startAt).format('YYYY-MM-DDTHH:mm') : '',
      endAt: item.endAt ? moment(item.endAt).format('YYYY-MM-DDTHH:mm') : '',
      targetMode: item.targetMode || 'all',
      targetStoreKeys: Array.isArray(item.targetStoreKeys) ? item.targetStoreKeys : [],
      displayPages: (Array.isArray(item.displayPages) && item.displayPages.length > 0)
        ? item.displayPages.slice()
        : ['dashboard'],
      showSkipToday: item.showSkipToday !== false
    };
    this.selectedTemplateKey = null;
    this.showEditor = true;
    this.storeSearchQuery = '';
    this.storeSearchResults = [];
    this.storeSearchOpen = false;
  };

  @action
  cancelEdit = () => {
    this.showEditor = false;
    this.resetForm();
  };

  @action
  removeItem = async (item) => {
    if (!item || !item._id) return;
    if (!window.confirm(`"${item.title || '(제목 없음)'}" 팝업을 삭제하시겠습니까?`)) return;
    let _this = this;
    this.props.removeAdminLoginNotice(item._id, function() {
      toast.success('삭제되었습니다.');
      _this.loadList();
      if (_this.editingId === item._id) _this.cancelEdit();
    });
  };

  @action
  toggleItemActive = (item) => {
    let _this = this;
    this.props.saveAdminLoginNotice({
      id: item._id,
      isActive: !item.isActive
    }, function() { _this.loadList(); });
  };

  @action
  onChange = (key, value) => {
    this.notice[key] = value;
  };

  @action
  togglePage = (pageKey) => {
    const cur = (this.notice.displayPages || []).slice();
    const idx = cur.indexOf(pageKey);
    if (idx === -1) cur.push(pageKey);
    else cur.splice(idx, 1);
    this.notice.displayPages = cur;
  };

  // 검색어 입력 — 250ms 디바운스
  @action
  onStoreSearchInput = (value) => {
    this.storeSearchQuery = value;
    this.storeSearchOpen = true;
    if (this.storeSearchTimer) clearTimeout(this.storeSearchTimer);
    if (!value || value.trim().length < 1) {
      this.storeSearchResults = [];
      this.storeSearchLoading = false;
      return;
    }
    this.storeSearchTimer = setTimeout(() => this.runStoreSearch(value.trim()), 250);
  };

  @action
  runStoreSearch = async (keyword) => {
    if (!this.props.getAllStoreList) return;
    this.storeSearchLoading = true;
    try {
      const res = await this.props.getAllStoreList({
        page: 1,
        limit: 20,
        sort: '-createdAt',
        searchParams: { keyword }
      });
      const docs = (res && Array.isArray(res.docs)) ? res.docs : [];
      this.storeSearchResults = docs;
    } catch (e) {
      this.storeSearchResults = [];
    }
    this.storeSearchLoading = false;
  };

  @action
  addStoreToTarget = (store) => {
    if (!store) return;
    const key = store.platformId || store._id;
    if (!key) return;
    const cur = (this.notice.targetStoreKeys || []).slice();
    if (cur.indexOf(key) !== -1) {
      toast.info('이미 추가된 스토어입니다.');
      return;
    }
    cur.push(key);
    this.notice.targetStoreKeys = cur;
    this.storeKeyToName[key] = store.name || store.platformId || key;
    this.storeSearchQuery = '';
    this.storeSearchResults = [];
    this.storeSearchOpen = false;
  };

  @action
  removeStoreFromTarget = (key) => {
    const cur = (this.notice.targetStoreKeys || []).filter(k => k !== key);
    this.notice.targetStoreKeys = cur;
  };

  @action
  closeStoreSearch = () => {
    this.storeSearchOpen = false;
  };

  getStoreDisplayName = (key) => {
    if (!key) return '';
    return this.storeKeyToName[key] || key;
  };

  @action
  applyTemplate = (tpl) => {
    this.selectedTemplateKey = tpl.key;
    this.notice.title = tpl.title || this.notice.title;
    this.notice.content = tpl.content;
    this.notice.accentColor = tpl.accentColor || this.notice.accentColor;
  };

  @action
  triggerUpload = () => {
    if (this.fileInputRef.current) this.fileInputRef.current.click();
  };

  // Quill 에디터 커서 위치에 이미지 삽입 (없으면 content 끝에 추가)
  insertImageToEditor = (imgUrl) => {
    try {
      const editor = this.quillRef.current && this.quillRef.current.getEditor();
      if (editor) {
        const range = editor.getSelection(true);
        const index = range ? range.index : editor.getLength();
        editor.insertEmbed(index, 'image', imgUrl, 'user');
        editor.setSelection(index + 1);
        return;
      }
    } catch (e) {}
    // fallback: content 끝에 img 태그 추가
    const imgTag = `<p><img src="${imgUrl}" alt="" /></p>`;
    this.notice.content = (this.notice.content || '') + imgTag;
  };

  @action
  handleFileUpload = async (event) => {
    const file = event.target.files && event.target.files[0];
    if (!file) return;
    if (!file.type.startsWith('image/')) {
      toast.error('이미지 파일만 업로드할 수 있습니다.');
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      toast.error('5MB 이하 이미지만 업로드할 수 있습니다.');
      return;
    }

    let _this = this;
    this.isUploading = true;

    const reader = new FileReader();
    reader.onload = function(e) {
      const base64 = e.target.result;
      const me = _this.props.me || {};
      _this.props.base64UploadImages({
        store_id: me.selStore_id || (me.store && me.store._id),
        base64Imgs: [{ image: base64 }]
      }, function(res) {
        _this.isUploading = false;
        if (res && res.errors && res.errors.length > 0) {
          toast.error(res.errors[0].message || '이미지 업로드에 실패했습니다.');
          return;
        }
        const imgUrl = res && res.images && res.images[0] ? res.images[0] : null;
        if (imgUrl) {
          _this.insertImageToEditor(imgUrl);
          toast.success('이미지가 본문에 삽입되었습니다.');
        } else {
          toast.error('이미지 업로드에 실패했습니다.');
        }
      });
    };
    reader.readAsDataURL(file);

    // 같은 파일 재선택 가능하도록 input 초기화
    event.target.value = '';
  };

  @action
  save = () => {
    if (this.notice.isActive && !this.notice.title) {
      toast.error('타이틀을 입력해 주세요.');
      return;
    }
    if (!Array.isArray(this.notice.displayPages) || this.notice.displayPages.length === 0) {
      toast.error('노출 페이지를 1개 이상 선택해 주세요.');
      return;
    }
    this.isLoading = true;
    let _this = this;
    const payload = {
      id: this.editingId || null,
      isActive: this.notice.isActive,
      title: this.notice.title,
      content: this.notice.content,
      backgroundColor: this.notice.backgroundColor,
      accentColor: this.notice.accentColor,
      startAt: this.notice.startAt ? moment(this.notice.startAt).toISOString() : '',
      endAt: this.notice.endAt ? moment(this.notice.endAt).toISOString() : '',
      targetMode: this.notice.targetMode || 'all',
      targetStoreKeys: this.notice.targetStoreKeys || [],
      displayPages: (this.notice.displayPages && this.notice.displayPages.length > 0)
        ? this.notice.displayPages
        : ['dashboard'],
      showSkipToday: !!this.notice.showSkipToday
    };
    this.props.saveAdminLoginNotice(payload, function(res) {
      _this.isLoading = false;
      if (res && res.errors && res.errors.length > 0) {
        toast.error(res.errors[0].message || '저장에 실패했습니다.');
      } else {
        toast.success(_this.editingId ? '팝업이 수정되었습니다.' : '새 팝업이 등록되었습니다.');
        _this.cancelEdit();
        _this.loadList();
      }
    });
  };

  // 팝업 카드 1개 렌더 (노출중/비활성 박스에서 공통 사용)
  renderNoticeCard = (item) => {
    const editing = this.editingId === item._id;
    const targetLabel = item.targetMode === 'include' ? `특정 ${(item.targetStoreKeys || []).length}개 노출`
                      : item.targetMode === 'exclude' ? `특정 ${(item.targetStoreKeys || []).length}개 제외`
                      : '모든 스토어';
    const pages = (Array.isArray(item.displayPages) && item.displayPages.length > 0) ? item.displayPages : ['dashboard'];
    const pageLabelMap = { dashboard: '대시보드', review: '리뷰/답글', widget: '위젯' };
    const pageLabel = pages.map(p => pageLabelMap[p] || p).join(' · ');
    return (
      <div key={item._id}
        style={{
          padding: '12px 14px',
          border: `1px solid ${editing ? '#4A6CF7' : '#E2E8F0'}`,
          borderRadius: 8,
          background: editing ? '#F8FAFF' : '#fff',
          boxShadow: editing ? '0 0 0 2px rgba(74,108,247,0.18)' : 'none',
          cursor: 'pointer',
          transition: 'all 120ms',
          opacity: (item.isActive || editing) ? 1 : 0.55
        }}
        onClick={() => this.startEdit(item)}>
        {/* 1행: 팝업 제목(왼쪽) + 스위치(오른쪽) */}
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, marginBottom: 8}}>
          <div style={{flex: 1, minWidth: 0, fontSize: 14, fontWeight: 700, color: '#1F2937', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>
            {item.title || <span style={{color: '#CBD5E1'}}>(제목 없음)</span>}
          </div>
          <span onClick={(e) => e.stopPropagation()} style={{display: 'inline-flex', alignItems: 'center', flexShrink: 0}}>
            <FormCheckbox toggle small checked={!!item.isActive} onChange={() => this.toggleItemActive(item)}>
              <span style={{fontSize: 11, fontWeight: 700, color: item.isActive ? '#059669' : '#9CA3AF'}}>
                {item.isActive ? '노출중' : '비활성'}
              </span>
            </FormCheckbox>
          </span>
        </div>
        {/* 2행: 스토어 노출 설정 + 페이지 노출 설정 */}
        <div style={{display: 'flex', alignItems: 'center', gap: 6, marginBottom: 8, flexWrap: 'wrap'}}>
          <span style={{
            padding: '2px 8px',
            borderRadius: 999,
            fontSize: 10,
            fontWeight: 600,
            background: item.targetMode === 'all' ? '#EEF2FF' : item.targetMode === 'include' ? '#FEF3C7' : '#FEE2E2',
            color: item.targetMode === 'all' ? '#4338CA' : item.targetMode === 'include' ? '#B45309' : '#B91C1C'
          }} title={`스토어 노출 설정: ${targetLabel}`}>{targetLabel}</span>
          <span style={{
            padding: '2px 8px',
            borderRadius: 999,
            fontSize: 10,
            fontWeight: 600,
            background: '#E0F2FE',
            color: '#075985'
          }} title={`페이지 노출 설정: ${pageLabel}`}>{pageLabel}</span>
        </div>
        {/* 3행: 날짜 */}
        <div style={{fontSize: 11, color: '#6B7280', marginBottom: 8}}>
          <FeatherIcon icon="calendar" size="11" style={{verticalAlign: '-1px'}} />{' '}
          {item.startAt || item.endAt
            ? `${item.startAt ? moment(item.startAt).format('YY.MM.DD') : '∞'} ~ ${item.endAt ? moment(item.endAt).format('YY.MM.DD') : '∞'}`
            : '상시 노출'}
        </div>
        {/* 4행: 버튼들 */}
        <div style={{display: 'flex', gap: 4}} onClick={(e) => e.stopPropagation()}>
          <Button size="sm" theme="primary" style={{flex: 1, padding: '4px 6px', fontSize: 11}}
            onClick={() => this.startEdit(item)}>
            <FeatherIcon icon="edit-2" size="11" /> 편집
          </Button>
          <Button size="sm" theme="danger" style={{flex: 1, padding: '4px 6px', fontSize: 11}}
            onClick={() => this.removeItem(item)}>
            <FeatherIcon icon="trash-2" size="11" />
          </Button>
        </div>
      </div>
    );
  };

  render() {
    const me = this.props.me || {};
    if (me.emailId !== 'admin@onnomads.com') return null;

    const { isActive, title, content, backgroundColor, accentColor, showSkipToday } = this.notice;
    const activeNotices = (this.notices || []).filter(n => n.isActive);
    const inactiveNotices = (this.notices || []).filter(n => !n.isActive);

    return (
      <div style={{padding: '0 16px 30px'}}>
        {/* Quill 에디터 + 미리보기 typography 보정 */}
        <style>{`
          .lnp-editor-wrap .ql-toolbar {
            border-top-left-radius: 6px;
            border-top-right-radius: 6px;
            background: #F8FAFC;
            border-color: #E2E8F0;
          }
          .lnp-editor-wrap .ql-container {
            border-bottom-left-radius: 6px;
            border-bottom-right-radius: 6px;
            min-height: 260px;
            font-family: 'Noto Sans KR', sans-serif;
            border-color: #E2E8F0;
          }
          .lnp-editor-wrap .ql-editor {
            min-height: 260px;
            font-size: 14px;
            line-height: 1.6;
          }
          .lnp-editor-wrap .ql-editor.ql-blank::before {
            color: #94A3B8;
            font-style: normal;
          }

          /* 미리보기 내부 typography — Quill HTML 이 보기 좋게 렌더링되도록 */
          .lnp-preview-body h1, .lnp-preview-body h2, .lnp-preview-body h3 {
            font-weight: 700;
            line-height: 1.3;
            margin: 14px 0 8px;
          }
          .lnp-preview-body h1 { font-size: 22px; }
          .lnp-preview-body h2 { font-size: 19px; }
          .lnp-preview-body h3 { font-size: 16px; }
          .lnp-preview-body p { margin: 8px 0; font-size: 14px; line-height: 1.7; color: #334155; }
          .lnp-preview-body ul, .lnp-preview-body ol { margin: 10px 0; padding-left: 22px; font-size: 14px; line-height: 1.9; color: #334155; }
          .lnp-preview-body ul li, .lnp-preview-body ol li { margin-bottom: 4px; }
          .lnp-preview-body strong { font-weight: 700; color: inherit; }
          .lnp-preview-body blockquote {
            border-left: 3px solid #CBD5E1;
            padding: 10px 14px;
            margin: 12px 0;
            background: #F8FAFC;
            border-radius: 0 6px 6px 0;
            font-size: 13px;
            color: #475569;
          }
          .lnp-preview-body a { color: #4A6CF7; text-decoration: underline; }
          .lnp-preview-body img { max-width: 100%; height: auto; border-radius: 6px; margin: 8px 0; }
          .lnp-preview-body hr { border: none; border-top: 1px solid #E2E8F0; margin: 14px 0; }

          /* 에디터 내부에도 동일 스타일 적용 (템플릿 미리보기와 일치) */
          .lnp-editor-wrap .ql-editor h1 { font-size: 22px; font-weight: 700; }
          .lnp-editor-wrap .ql-editor h2 { font-size: 19px; font-weight: 700; }
          .lnp-editor-wrap .ql-editor h3 { font-size: 16px; font-weight: 700; }
          .lnp-editor-wrap .ql-editor blockquote {
            border-left: 3px solid #CBD5E1;
            padding: 8px 12px;
            background: #F8FAFC;
            color: #475569;
          }
        `}</style>
        <PageTitle title="팝업 설정" subtitle="스토어 관리" className="mb-3" />

        {/* === 등록된 팝업: 노출중 / 비활성 2개 박스 === */}
        {/* 노출중 팝업 박스 */}
        <Card className="mb-3">
          <CardHeader style={{padding: '12px 18px', borderBottom: '1px solid #f0f0f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
            <span style={{fontSize: '14px', fontWeight: 600, color: '#059669', display: 'inline-flex', alignItems: 'center', gap: 6}}>
              <FeatherIcon icon="eye" size="15" /> 노출중 팝업 ({activeNotices.length}개)
            </span>
            <Button theme="primary" size="sm" onClick={() => this.startCreate()}>
              <FeatherIcon icon="plus" size="13" /> 새 팝업
            </Button>
          </CardHeader>
          <CardBody style={{padding: '14px 18px'}}>
            {activeNotices.length === 0 ? (
              <div style={{padding: '24px 16px', textAlign: 'center', color: '#94A3B8', fontSize: 13}}>
                <FeatherIcon icon="bell-off" size="28" style={{color: '#CBD5E1', marginBottom: 6}} />
                <div>노출중인 팝업이 없습니다.</div>
              </div>
            ) : (
              <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 10}}>
                {activeNotices.map(item => this.renderNoticeCard(item))}
              </div>
            )}
          </CardBody>
        </Card>

        {/* 비활성 팝업 박스 */}
        <Card className="mb-3">
          <CardHeader style={{padding: '12px 18px', borderBottom: '1px solid #f0f0f0', display: 'flex', alignItems: 'center'}}>
            <span style={{fontSize: '14px', fontWeight: 600, color: '#6B7280', display: 'inline-flex', alignItems: 'center', gap: 6}}>
              <FeatherIcon icon="eye-off" size="15" /> 비활성 팝업 ({inactiveNotices.length}개)
            </span>
          </CardHeader>
          <CardBody style={{padding: '14px 18px'}}>
            {inactiveNotices.length === 0 ? (
              <div style={{padding: '24px 16px', textAlign: 'center', color: '#94A3B8', fontSize: 13}}>
                <div>비활성 팝업이 없습니다.</div>
              </div>
            ) : (
              <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 10}}>
                {inactiveNotices.map(item => this.renderNoticeCard(item))}
              </div>
            )}
          </CardBody>
        </Card>

        {!this.showEditor ? (
          <div style={{padding: '20px', textAlign: 'center', color: '#94A3B8', fontSize: 13, background: '#FAFBFD', border: '1px dashed #CBD5E1', borderRadius: 8}}>
            팝업을 편집하려면 위 카드를 클릭하거나 <strong>새 팝업</strong> 버튼을 누르세요.
          </div>
        ) : (
        <Row>
          {/* === 좌측: 설정 === */}
          <Col lg="7" md="12">
            {/* 템플릿 선택 */}
            <Card className="mb-3">
              <CardHeader style={{padding: '12px 18px', borderBottom: '1px solid #f0f0f0'}}>
                <span style={{fontSize: '14px', fontWeight: 600}}>
                  <FeatherIcon icon="layout" size="14" /> 템플릿 선택
                </span>
              </CardHeader>
              <CardBody style={{padding: '14px 18px'}}>
                <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))', gap: '10px'}}>
                  {TEMPLATES.map(tpl => {
                    const active = this.selectedTemplateKey === tpl.key;
                    return (
                      <div key={tpl.key}
                           onClick={() => this.applyTemplate(tpl)}
                           style={{
                             padding: '14px 10px',
                             textAlign: 'center',
                             background: active ? '#EEF2FF' : '#fff',
                             border: `2px solid ${active ? '#4A6CF7' : '#E2E8F0'}`,
                             borderRadius: '10px',
                             cursor: 'pointer',
                             transition: 'all 180ms ease-in-out'
                           }}>
                        <div style={{
                          width: '36px', height: '36px', margin: '0 auto 6px',
                          borderRadius: '50%',
                          background: active ? '#4A6CF7' : '#F1F5F9',
                          color: active ? '#fff' : '#64748B',
                          display: 'flex', alignItems: 'center', justifyContent: 'center'
                        }}>
                          <FeatherIcon icon={tpl.icon} size="18" />
                        </div>
                        <div style={{fontSize: '12px', fontWeight: 600, color: active ? '#4A6CF7' : '#475569'}}>
                          {tpl.label}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </CardBody>
            </Card>

            {/* 기본 설정 */}
            <Card className="mb-3">
              <CardHeader style={{padding: '12px 18px', borderBottom: '1px solid #f0f0f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <span style={{fontSize: '14px', fontWeight: 600}}>
                  <FeatherIcon icon="edit-3" size="14" /> 기본 설정
                </span>
                <FormCheckbox toggle small checked={isActive}
                  onChange={() => this.onChange('isActive', !isActive)}>
                  {isActive ? '노출 중' : '노출 안 함'}
                </FormCheckbox>
              </CardHeader>
              <CardBody style={{padding: '18px'}}>
                <div className="mb-3">
                  <label style={{fontSize: '13px', fontWeight: 600, color: '#475569'}}>타이틀</label>
                  <FormInput value={title}
                    onChange={(e) => this.onChange('title', e.target.value)}
                    placeholder="예: v2.0 업데이트 안내"
                    maxLength="120" />
                </div>

                <div className="mb-2">
                  <label style={{fontSize: '13px', fontWeight: 600, color: '#475569', margin: 0}}>본문 내용</label>
                </div>
                <div className="lnp-editor-wrap">
                  <ReactQuill
                    ref={this.quillRef}
                    theme="snow"
                    value={content || ''}
                    onChange={(val) => this.onChange('content', val)}
                    modules={this.quillModules}
                    formats={this.quillFormats}
                    placeholder="템플릿을 선택하거나 직접 입력하세요..."
                  />
                  <input type="file" accept="image/*" ref={this.fileInputRef}
                         onChange={(e) => this.handleFileUpload(e)}
                         style={{display: 'none'}} />
                </div>
                <div style={{fontSize: '11px', color: '#94A3B8', marginTop: 6}}>
                  툴바의 이미지 아이콘 <FeatherIcon icon="image" size="11" />을 클릭해 이미지를 업로드하면 커서 위치에 삽입됩니다.
                  {this.isUploading && <span style={{marginLeft: 8, color: '#4A6CF7', fontWeight: 600}}>업로드 중...</span>}
                </div>

                <Row className="mt-3">
                  <Col md="6" className="mb-2">
                    <label style={{fontSize: '13px', fontWeight: 600, color: '#475569'}}>노출 시작 (선택)</label>
                    <FormInput type="datetime-local" value={this.notice.startAt}
                      onChange={(e) => this.onChange('startAt', e.target.value)} />
                  </Col>
                  <Col md="6" className="mb-2">
                    <label style={{fontSize: '13px', fontWeight: 600, color: '#475569'}}>노출 종료 (선택)</label>
                    <FormInput type="datetime-local" value={this.notice.endAt}
                      onChange={(e) => this.onChange('endAt', e.target.value)} />
                  </Col>
                </Row>

                {/* "오늘 하루 보지 않기" 사용 여부 */}
                <div className="mt-3" style={{padding: '10px 12px', background: '#F8FAFC', border: '1px solid #E2E8F0', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10}}>
                  <div>
                    <div style={{fontSize: 13, fontWeight: 600, color: '#475569'}}>"오늘 하루 보지 않기" 버튼 노출</div>
                    <div style={{fontSize: 11, color: '#94A3B8', marginTop: 2}}>
                      끄면 사용자가 팝업을 임시로 숨길 수 없으며, 매번 로그인 시 재노출됩니다 (중요 공지에 권장).
                    </div>
                  </div>
                  <FormCheckbox toggle small checked={!!this.notice.showSkipToday}
                    onChange={() => this.onChange('showSkipToday', !this.notice.showSkipToday)}>
                    {this.notice.showSkipToday ? '사용함' : '사용 안 함'}
                  </FormCheckbox>
                </div>

                {/* 노출 페이지 선택 */}
                <div className="mt-3">
                  <label style={{fontSize: '13px', fontWeight: 600, color: '#475569', marginBottom: 6, display: 'block'}}>
                    노출 페이지
                  </label>
                  <div style={{display: 'flex', flexDirection: 'column', gap: 6}}>
                    {[
                      {v: 'dashboard', l: '대시보드',                  desc: '/dashboard',                                   icon: 'home'},
                      {v: 'review',    l: '리뷰/답글 (하위 모든 페이지)', desc: '리뷰 리스트, 작성, 설정, 답글 등 리뷰 관련 메뉴', icon: 'message-square'},
                      {v: 'widget',    l: '리뷰 위젯 (하위 모든 페이지)', desc: '페이지별 위젯, 그리드 위젯, 메타 위젯 등',         icon: 'layout'}
                    ].map(opt => {
                      const checked = (this.notice.displayPages || []).indexOf(opt.v) !== -1;
                      return (
                        <label key={opt.v} style={{
                          display: 'flex', alignItems: 'flex-start', gap: 10,
                          padding: '10px 12px',
                          border: `1px solid ${checked ? '#4A6CF7' : '#E2E8F0'}`,
                          background: checked ? '#F8FAFF' : '#fff',
                          borderRadius: 6, cursor: 'pointer',
                          transition: 'all 120ms'
                        }}>
                          <input type="checkbox" checked={checked}
                            onChange={() => this.togglePage(opt.v)}
                            style={{marginTop: 3, accentColor: '#4A6CF7'}} />
                          <div style={{flex: 1, minWidth: 0}}>
                            <div style={{display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, fontWeight: 600, color: checked ? '#4A6CF7' : '#1F2937'}}>
                              <FeatherIcon icon={opt.icon} size="13" /> {opt.l}
                            </div>
                            <div style={{fontSize: 11, color: '#94A3B8', marginTop: 2}}>{opt.desc}</div>
                          </div>
                        </label>
                      );
                    })}
                  </div>
                  {(this.notice.displayPages || []).length === 0 && (
                    <div style={{marginTop: 6, padding: '6px 10px', background: '#FEE2E2', border: '1px solid #FECACA', borderRadius: 4, fontSize: 11, color: '#B91C1C'}}>
                      <FeatherIcon icon="alert-circle" size="11" /> 최소 1개 이상의 노출 페이지를 선택해야 합니다.
                    </div>
                  )}
                </div>

                {/* 타겟 스토어 — 모든 스토어 / 특정 스토어만 / 특정 스토어 제외 */}
                <div className="mt-3">
                  <label style={{fontSize: '13px', fontWeight: 600, color: '#475569', marginBottom: 6, display: 'block'}}>
                    노출 대상 스토어
                  </label>
                  <div style={{display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 8}}>
                    {[
                      {v: 'all',     l: '모든 스토어',     icon: 'globe'},
                      {v: 'include', l: '특정 스토어만',   icon: 'check-circle'},
                      {v: 'exclude', l: '특정 스토어 제외', icon: 'slash'}
                    ].map(opt => {
                      const active = this.notice.targetMode === opt.v;
                      return (
                        <button key={opt.v} type="button"
                          onClick={() => this.onChange('targetMode', opt.v)}
                          style={{
                            display: 'inline-flex', alignItems: 'center', gap: 4,
                            padding: '6px 12px',
                            border: `1px solid ${active ? '#4A6CF7' : '#E2E8F0'}`,
                            background: active ? '#EEF2FF' : '#fff',
                            color: active ? '#4A6CF7' : '#475569',
                            borderRadius: 999, fontSize: 12, fontWeight: 600,
                            cursor: 'pointer', transition: 'all 120ms'
                          }}>
                          <FeatherIcon icon={opt.icon} size="12" /> {opt.l}
                        </button>
                      );
                    })}
                  </div>
                  {(this.notice.targetMode === 'include' || this.notice.targetMode === 'exclude') && (
                    <>
                      {/* 검색 입력 */}
                      <div style={{position: 'relative'}}>
                        <div style={{position: 'relative'}}>
                          <FeatherIcon icon="search" size="14"
                            style={{position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', color: '#94A3B8', pointerEvents: 'none'}} />
                          <FormInput
                            value={this.storeSearchQuery}
                            onChange={(e) => this.onStoreSearchInput(e.target.value)}
                            onFocus={() => { if (this.storeSearchResults.length > 0) this.storeSearchOpen = true; }}
                            placeholder="스토어명, platformId, 도메인, 이메일로 검색…"
                            style={{paddingLeft: 30}}
                          />
                          {this.storeSearchLoading && (
                            <span style={{position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', fontSize: 11, color: '#4A6CF7'}}>검색 중…</span>
                          )}
                        </div>

                        {/* 검색 결과 드롭다운 */}
                        {this.storeSearchOpen && this.storeSearchQuery && (
                          <div style={{
                            position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 50,
                            marginTop: 4, background: '#fff', border: '1px solid #E2E8F0',
                            borderRadius: 6, boxShadow: '0 6px 16px rgba(0,0,0,0.08)',
                            maxHeight: 260, overflowY: 'auto'
                          }}>
                            {this.storeSearchResults.length === 0 && !this.storeSearchLoading && (
                              <div style={{padding: '14px 12px', fontSize: 12, color: '#94A3B8', textAlign: 'center'}}>
                                검색 결과가 없습니다.
                              </div>
                            )}
                            {this.storeSearchResults.map(store => {
                              const key = store.platformId || store._id;
                              const already = (this.notice.targetStoreKeys || []).indexOf(key) !== -1;
                              return (
                                <div key={store._id || key}
                                  onClick={() => !already && this.addStoreToTarget(store)}
                                  style={{
                                    padding: '8px 12px',
                                    borderBottom: '1px solid #F1F5F9',
                                    cursor: already ? 'not-allowed' : 'pointer',
                                    background: already ? '#F8FAFC' : '#fff',
                                    opacity: already ? 0.6 : 1,
                                    display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8
                                  }}
                                  onMouseEnter={(e) => { if (!already) e.currentTarget.style.background = '#F8FAFF'; }}
                                  onMouseLeave={(e) => { if (!already) e.currentTarget.style.background = '#fff'; }}>
                                  <div style={{minWidth: 0, flex: 1}}>
                                    <div style={{fontSize: 13, fontWeight: 600, color: '#1F2937', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                                      {store.name || <span style={{color: '#CBD5E1'}}>(이름 없음)</span>}
                                    </div>
                                    <div style={{fontSize: 11, color: '#64748B', marginTop: 1}}>
                                      <code style={{background: '#F1F5F9', padding: '0 4px', borderRadius: 3}}>{store.platformId || '-'}</code>
                                    </div>
                                  </div>
                                  {already
                                    ? <span style={{fontSize: 11, color: '#94A3B8'}}><FeatherIcon icon="check" size="11"/> 추가됨</span>
                                    : <span style={{fontSize: 11, color: '#4A6CF7', fontWeight: 600}}><FeatherIcon icon="plus" size="11"/> 추가</span>}
                                </div>
                              );
                            })}
                            <div style={{padding: '6px 10px', background: '#F8FAFC', borderTop: '1px solid #F1F5F9', fontSize: 10, color: '#94A3B8', textAlign: 'right'}}>
                              <button type="button" onClick={() => this.closeStoreSearch()}
                                style={{background: 'none', border: 0, color: '#64748B', cursor: 'pointer', padding: 0, fontSize: 10}}>닫기</button>
                            </div>
                          </div>
                        )}
                      </div>

                      {/* 선택된 스토어 칩 */}
                      <div style={{
                        marginTop: 8, padding: 8, minHeight: 38,
                        border: '1px dashed #CBD5E1', borderRadius: 6,
                        background: '#FAFBFD', display: 'flex', flexWrap: 'wrap', gap: 6
                      }}>
                        {(this.notice.targetStoreKeys || []).length === 0 ? (
                          <span style={{fontSize: 11, color: '#94A3B8', padding: '4px 6px'}}>
                            선택된 스토어가 없습니다. 위 검색창에서 스토어를 검색하여 추가하세요.
                          </span>
                        ) : (
                          (this.notice.targetStoreKeys || []).map(key => (
                            <span key={key} style={{
                              display: 'inline-flex', alignItems: 'center', gap: 4,
                              padding: '4px 4px 4px 10px',
                              background: '#fff', border: '1px solid #E2E8F0', borderRadius: 999,
                              fontSize: 12, color: '#1F2937'
                            }}>
                              <span style={{fontWeight: 600, maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                                {this.getStoreDisplayName(key)}
                              </span>
                              <code style={{fontSize: 10, color: '#64748B', background: '#F1F5F9', padding: '0 4px', borderRadius: 3}}>{key}</code>
                              <button type="button" onClick={() => this.removeStoreFromTarget(key)}
                                style={{
                                  background: '#F1F5F9', border: 0, borderRadius: '50%',
                                  width: 18, height: 18, display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                  cursor: 'pointer', color: '#64748B', padding: 0
                                }}
                                title="제거">
                                <FeatherIcon icon="x" size="11" />
                              </button>
                            </span>
                          ))
                        )}
                      </div>

                      <div style={{marginTop: 6, padding: '6px 10px', background: '#FEF3C7', border: '1px solid #FDE68A', borderRadius: 4, fontSize: 11, color: '#92400E'}}>
                        <FeatherIcon icon="alert-triangle" size="11" />
                        {this.notice.targetMode === 'include'
                          ? <> 위 <strong>{(this.notice.targetStoreKeys || []).length}개</strong> 스토어에서만 팝업이 노출됩니다.</>
                          : <> 위 <strong>{(this.notice.targetStoreKeys || []).length}개</strong> 스토어에서는 팝업이 <strong>노출되지 않습니다.</strong></>}
                      </div>
                    </>
                  )}
                </div>
              </CardBody>
            </Card>

            {/* 디자인 */}
            <Card className="mb-3">
              <CardHeader style={{padding: '12px 18px', borderBottom: '1px solid #f0f0f0'}}>
                <span style={{fontSize: '14px', fontWeight: 600}}>
                  <FeatherIcon icon="droplet" size="14" /> 디자인
                </span>
              </CardHeader>
              <CardBody style={{padding: '18px'}}>
                <Row>
                  <Col md="6" className="mb-2">
                    <label style={{fontSize: '13px', fontWeight: 600, color: '#475569'}}>배경색</label>
                    <div style={{display: 'flex', gap: '8px', alignItems: 'center'}}>
                      <input type="color" value={backgroundColor}
                        onChange={(e) => this.onChange('backgroundColor', e.target.value)}
                        style={{width: '44px', height: '34px', border: '1px solid #E2E8F0', borderRadius: '6px', cursor: 'pointer'}} />
                      <FormInput value={backgroundColor}
                        onChange={(e) => this.onChange('backgroundColor', e.target.value)} />
                    </div>
                  </Col>
                  <Col md="6" className="mb-2">
                    <label style={{fontSize: '13px', fontWeight: 600, color: '#475569'}}>강조 색상</label>
                    <div style={{display: 'flex', gap: '8px', alignItems: 'center'}}>
                      <input type="color" value={accentColor}
                        onChange={(e) => this.onChange('accentColor', e.target.value)}
                        style={{width: '44px', height: '34px', border: '1px solid #E2E8F0', borderRadius: '6px', cursor: 'pointer'}} />
                      <FormInput value={accentColor}
                        onChange={(e) => this.onChange('accentColor', e.target.value)} />
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>

            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px'}}>
              <span style={{fontSize: 12, color: '#6B7280'}}>
                {this.editingId ? <><FeatherIcon icon="edit-3" size="12"/> 편집 중 <code style={{background: '#F1F5F9', padding: '1px 5px', borderRadius: 3}}>{String(this.editingId).slice(-6)}</code></> : <><FeatherIcon icon="plus-circle" size="12"/> 새 팝업 작성</>}
              </span>
              <div style={{display: 'flex', gap: 8}}>
                <Button theme="light" onClick={() => this.cancelEdit()}>취소</Button>
                <Button theme="primary" onClick={() => this.save()} disabled={this.isLoading}>
                  <FeatherIcon icon="save" size="13" /> {this.editingId ? '수정 저장' : '신규 등록'}
                </Button>
              </div>
            </div>
          </Col>

          {/* === 우측: 실시간 미리보기 === */}
          <Col lg="5" md="12">
            <div style={{position: 'sticky', top: '16px'}}>
              <Card>
                <CardHeader style={{padding: '12px 18px', borderBottom: '1px solid #f0f0f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                  <span style={{fontSize: '14px', fontWeight: 600}}>
                    <FeatherIcon icon="eye" size="14" /> 실시간 미리보기
                  </span>
                  <span style={{fontSize: '11px', color: '#94A3B8'}}>로그인 시 노출될 모습</span>
                </CardHeader>
                <CardBody style={{padding: '20px', background: '#F8FAFC', minHeight: '520px', display: 'flex', alignItems: 'flex-start', justifyContent: 'center'}}>
                  {/* 실제 모달 마크업 재현 */}
                  <div style={{
                    width: '100%',
                    maxWidth: '440px',
                    background: backgroundColor || '#fff',
                    borderRadius: '10px',
                    overflow: 'hidden',
                    boxShadow: '0 10px 24px rgba(0,0,0,0.12)'
                  }}>
                    <div style={{
                      padding: '18px 20px',
                      borderBottom: `3px solid ${accentColor || '#4A6CF7'}`,
                      color: accentColor || '#4A6CF7',
                      display: 'flex', justifyContent: 'space-between', alignItems: 'center'
                    }}>
                      <h5 style={{margin: 0, fontSize: '16px', fontWeight: 700}}>
                        {title || <span style={{color: '#CBD5E1'}}>(타이틀 미입력)</span>}
                      </h5>
                      <FeatherIcon icon="x" size="18" style={{color: 'inherit'}} />
                    </div>
                    <div style={{padding: '20px'}}>
                      <div className="lnp-preview-body"
                           dangerouslySetInnerHTML={{__html: content || '<p style="color:#CBD5E1">본문 내용이 비어 있습니다.</p>'}} />
                      <div style={{marginTop: '20px', display: 'flex', justifyContent: showSkipToday ? 'space-between' : 'flex-end', alignItems: 'center'}}>
                        {showSkipToday && (
                          <span style={{fontSize: '12px', color: '#64748B'}}>오늘 하루 보지 않기</span>
                        )}
                        <div style={{
                          background: accentColor || '#4A6CF7',
                          color: '#fff',
                          padding: '9px 20px',
                          borderRadius: '6px',
                          fontSize: '13px',
                          fontWeight: 600
                        }}>확인</div>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>

              {!isActive && (
                <div style={{marginTop: '10px', padding: '10px 14px', background: '#FEF3C7', border: '1px solid #FDE68A', borderRadius: '6px', fontSize: '12px', color: '#92400E'}}>
                  <FeatherIcon icon="alert-triangle" size="12" /> 현재 <strong>노출 안 함</strong> 상태입니다. 상단 토글을 켜면 관리자 로그인 시 실제로 노출됩니다.
                </div>
              )}
            </div>
          </Col>
        </Row>
        )}
      </div>
    );
  }
}

export default LoginNoticePopup;
